import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  titleKey: string,
  value: string,
};

class TileInformationBlock extends React.PureComponent<Props> {
  render(): ReactNode {
    return (
      <div className="information-block">
        <div className="information-title caption">
          <Translate value={this.props.titleKey} />
        </div>
        <div className="information">
          {this.props.value}
        </div>
      </div>

    );
  }
}

export default TileInformationBlock;
